module.exports = __webpack_public_path__ + "c0b8804ae85213c9194816da945db150.woff";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-Regular.woff
// module id = 1802
// module chunks = 1